import { type ReactNode } from 'react';
import { StyledPagePanel } from './styles';

type PagePanelProps = {
  children: ReactNode;
  overflow?: 'hidden' | 'visible';
  padding?: number | string;
};

export const PagePanel = ({
  children,
  overflow = 'visible',
  padding = '32px',
}: PagePanelProps) => {
  return (
    <StyledPagePanel $overflow={overflow} $padding={padding}>
      {children}
    </StyledPagePanel>
  );
};
